export default __webpack_public_path__ + "img/financials.f0c1b8.svg";